import React from 'react';

const InfiniteLogoSlider = ({ 
  children, 
  width = "200px", 
  duration = 20, 
  toRight = false, 
  pauseOnHover = false, 
  blurBorders = false, 
  blurBorderColor = "#f9fafb" 
}) => {
  const containerClasses = `
    infinite-logo-slider 
    ${blurBorders ? 'with-blur' : ''} 
    ${pauseOnHover ? 'pause-on-hover' : ''}
  `.trim();

  const childrenCount = React.Children.count(children);
  const trackStyle = {
    animationDuration: `${duration}s`,
    animationDirection: toRight ? 'normal' : 'reverse',
    '--children-count': childrenCount
  };

  const slideStyle = {
    width: width
  };

  return (
    <div className={containerClasses} style={{ '--blur-color': blurBorderColor }}>
      <div className="infinite-logo-track-seamless" style={trackStyle}>
        {/* Render children multiple times for truly seamless loop */}
        {React.Children.map(children, (child, index) => (
          <div key={`first-${index}`} className="infinite-logo-slide" style={slideStyle}>
            {child}
          </div>
        ))}
        {React.Children.map(children, (child, index) => (
          <div key={`second-${index}`} className="infinite-logo-slide" style={slideStyle}>
            {child}
          </div>
        ))}
        {React.Children.map(children, (child, index) => (
          <div key={`third-${index}`} className="infinite-logo-slide" style={slideStyle}>
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfiniteLogoSlider; 